import React, { Component } from 'react';

import store from '../store';

function withStore(WrappedComponent) {
  return class extends Component {
    render() {
      return <WrappedComponent {...this.props} store={store}/>;
    }
  };
}

export default withStore;
